import { render, staticRenderFns } from "./SectionGrid.vue?vue&type=template&id=b8a2ccb4"
import script from "./SectionGrid.vue?vue&type=script&lang=js"
export * from "./SectionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports